// Pure display helpers for the live run telemetry on the status cards. Kept out of
// ManageAutomation.js so they can be unit-tested — the page has no component harness
// (same split as runStatsSummary.js).

export const formatDuration = (ms) => {
    if (!Number.isFinite(ms) || ms < 0) return null
    const totalSeconds = Math.floor(ms / 1000)
    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60
    if (hours > 0) return `${hours}h ${minutes}m`
    if (minutes > 0) return `${minutes}m ${seconds}s`
    return `${seconds}s`
}

// Average-pace extrapolation; null until the first item completes, since there is no
// pace to extrapolate from before that. Deliberately unsmoothed — per-violation times
// vary wildly (source + LLM latency), and admins only need an order of magnitude.
export const computeEtaMs = (progress, elapsedMs) => {
    if (!progress || !progress.total || !progress.done) return null
    if (!Number.isFinite(elapsedMs) || elapsedMs <= 0) return null
    const remaining = progress.total - progress.done
    if (remaining <= 0) return 0
    return Math.round((elapsedMs / progress.done) * remaining)
}

// "Violation 7 of 23" — names the item being worked (done + 1, capped at the total).
export const progressLabel = (progress) => {
    if (!progress || !progress.total) return null
    return `Violation ${Math.min(progress.done + 1, progress.total)} of ${progress.total}`
}

export const progressPercent = (progress) => {
    if (!progress || !progress.total) return null
    return Math.min(100, (progress.done / progress.total) * 100)
}
